import { createAction } from "@reduxjs/toolkit";

import type { sendErrorUINotification } from "utils/notification";

export const createErrorUINotification = createAction<
  Parameters<typeof sendErrorUINotification>[0]
>("CREATE_ERROR_UI_NOTIFICATION");
